export default __webpack_public_path__ + "static/media/kpmg_hero_2.4a272cd7.jpg";